import {
  GoogleMapsFeature,
  GoogleMapsQueryFeatureService,
} from '@sbb-amsgis/google-maps';
import {GoogleMapConfig, GoogleMapFeatureConfig} from '../models/google-map-config.model';
import { GOOGLE_MAP_CONFIG_TOKEN } from '../../../../../assets/config/shared/google-map.config';
import { Injectable } from '@angular/core';
import { inject } from '@angular/core';
import Graphic from '@arcgis/core/Graphic';
import { LayerQueryService } from '../../../../shared/service/layer-query.service';
import { map, switchMap } from 'rxjs/operators';
import { GoogleMapsFeatureTransform } from '../helpers/google-maps-feature-transform';
import { ConfigService } from '../../../../config/config.service';
import { ArbeitsbereichService } from '../../../../shared/service/arbeitsbereich.service';
import {LayerCode} from '../../../../shared/enum/layer-code.enum';
import {Observable} from 'rxjs/internal/Observable';
import {forkJoin} from 'rxjs/internal/observable/forkJoin';
import {of} from 'rxjs/internal/observable/of';

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsToolService implements GoogleMapsQueryFeatureService {
  private readonly _googleMapConfig: GoogleMapConfig = inject(GOOGLE_MAP_CONFIG_TOKEN);
  private readonly _googleMapsFeatureTransform: GoogleMapsFeatureTransform = new GoogleMapsFeatureTransform();

  constructor(
    private readonly _layerQueryService: LayerQueryService,
    private readonly _configService: ConfigService,
    private readonly _arbeitsbereichService: ArbeitsbereichService
  ) {}

  getFeaturesInExtent(extent: __esri.Geometry): Observable<GoogleMapsFeature[]> {
    const observables = [];
    const currentArbeitsBereich = this._arbeitsbereichService.selectedArbeitsbereich;

    const currentConfig = this._configService.detailViewConfig.detailviews.find(
      x => x.fkArbeitsbereich === currentArbeitsBereich.id
    );
    currentConfig.forms.forEach(detailView => {
      const googleFeatureConfig = this.getGoogleConfig(currentConfig.fkIdentifyLayer as LayerCode, detailView.fkIdentifyLayerId);
      if (googleFeatureConfig) {
        const layerId = googleFeatureConfig.queryLayerId;
        const layerUrl = this._configService.getLayerUrl(layerId);
        observables.push(
          this._layerQueryService
            .getInfosByGraphicsXY(new Graphic({ geometry: extent }), layerId)
            .pipe(
              switchMap(result => {
                return result
                  ? this._googleMapsFeatureTransform.transform(
                      result.features,
                    googleFeatureConfig,
                      detailView,
                      layerUrl
                    )
                  : of([]);
              })
            )
        );
      }
    });

    return forkJoin(observables).pipe(
      map((results: GoogleMapsFeature[][]) => {
        return results.reduce((acc, val) => acc.concat(val), []);
      })
    );
  }
  private getGoogleConfig(fkIdentifyLayer: LayerCode, fkIdentifyLayerId: number): GoogleMapFeatureConfig {
    if (!fkIdentifyLayer || isNaN(fkIdentifyLayerId)) {
      return null;
    }
    return this._googleMapConfig.featureConfig.find(x => x.fkIdentifyLayer === fkIdentifyLayer && x.fkIdentifyLayerId === fkIdentifyLayerId);
  }
}
